import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { hasPerm } from "@/lib/perms";

// Visibility guard only; the backend enforces every permission independently.
export function PermRoute({ perm, children }) {
  const { user } = useAuth();
  if (!hasPerm(user, perm)) return <Navigate to="/agent/dashboard" replace />;
  return children;
}
